import { supportContent } from '@/config/marketing-content/commercial-pages'
import { MarketingHero } from '@/components/marketing/marketing-hero'

export function SupportPage() {
  return (
    <main>
      <MarketingHero
        className="marketing-hero--compact"
        eyebrow={supportContent.eyebrow}
        title={supportContent.heroTitle}
        lead={supportContent.heroLead}
      />

      <section className="support-cards-section">
        <div className="marketing-container">
          <ul className="support-cards">
            {supportContent.cards.map((card) => (
              <li key={card.title} className="support-card">
                <h2 className="support-card__title">{card.title}</h2>
                <p className="support-card__description">{card.description}</p>
                <a href={card.href} className="support-card__link">
                  {card.linkLabel}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </main>
  )
}
